<template>
	<component :is="tag" :style="style"><input v-if="rowKey" type="checkbox" v-model="state"></component>
</template>

<script setup lang="ts">
import {extractDataVariable, injectItemsGrid} from "./AgendaUtils";
import {computed, type CSSProperties, inject} from "vue";
import {injectSelection, type RowSelection} from "./RowSelection";
import type {DataColumn} from "@t/fd/layout/Agenda.ts";

const props = withDefaults(defineProps<{
	object: object,
	col: DataColumn,
	tag?: string
}>(), { tag: "td" });

const ag = injectItemsGrid();
const sel:RowSelection = injectSelection();

const KEY_SEPARATOR = "$";

const rowKey = computed<any>(() => {
	if (ag.value.identity) {
		const formData = {};	// not relevant for identity.
		let first = false;
		let k = "";
		for (let g of ag.value.identity) {
			let val = extractDataVariable(props.object, g, formData);
			if (first) first = false;
			else k += KEY_SEPARATOR;
			if (val != null) {
				k += val.toString();
			}
		}
		return k;
	}
	return "";
});

const state = computed({
	get():boolean {
		return sel.get(rowKey.value);
	},
	set(v:boolean):void {
		sel.set(rowKey.value, v);
	}
});

const style = computed<CSSProperties>(() => {
	if (props.tag === "td") return { textAlign: "center" };
	return {}
});

</script>

<style>

</style>
